/* eslint-disable no-unused-vars */
import PropTypes from 'prop-types';
import * as S from './Label.styled';
import { Question, WarningIcon, ErrorIcon, SuccessIcon } from 'assets/icons';

const variantsConfig = {
  label: { styleComponent: S.Variant1 },
  labelAndIcon: { styleComponent: S.Variant2, hasLastIcon: true },
  description: { styleComponent: S.Variant3 },
  descriptionAndIcon: { styleComponent: S.Variant4, lastIcon: true },
  warningDesc: {
    styleComponent: S.Variant5,
    lastIcon: false,
    iconFirst: WarningIcon,
    hasFirstIcon: true,
  },
  errorDesc: {
    styleComponent: S.Variant6,
    lastIcon: false,
    iconFirst: ErrorIcon,
    hasFirstIcon: true,
  },
  successDesc: {
    styleComponent: S.Variant7,
    lastIcon: false,
    iconFirst: SuccessIcon,
    hasFirstIcon: true,
  },
};

export const Label = ({ variant, text, style }) => {
  const baseStyle = { display: 'flex', alignItems: 'center', ...style };
  const config = variantsConfig[variant] || {};
  const IconFirst = config.iconFirst;

  return (
    <config.styleComponent style={baseStyle}>
      {config.hasFirstIcon && <IconFirst />}
      {text}
      {config.hasLastIcon && <Question />}
    </config.styleComponent>
  );
};

Label.propTypes = {
  variant: PropTypes.oneOf([
    'label',
    'labelAndIcon',
    'description',
    'descriptionAndIcon',
    'warningDesc',
    'errorDesc',
    'successDesc',
  ]).isRequired,
  //text: PropTypes.string.isRequired,
};
